

import { Box, styled } from '@mui/material';
import { FC, useContext, useMemo } from 'react';
import { Link as RouteLink } from "react-router-dom";
import { SpeciesTypes } from '../../constants/species/Species';
import { SpeciesContext } from '../../contexts/data/SpeciesContext';
import Image from '../common/Image';

// -- Header logos --
import FeralScanLogo from '../../assets/images/feral-scan/feralscan-logo-bright-crop.png';
import DeerLogo from '../../assets/images/feral-scan/species/deer/logo.svg';
import FeralCatLogo from '../../assets/images/feral-scan/species/feral-cat/logo.svg';
import FeralFishLogo from '../../assets/images/feral-scan/species/feral-fish/logo.svg';
import FeralGoatLogo from '../../assets/images/feral-scan/species/feral-goat/logo.svg';
import FeralPigLogo from '../../assets/images/feral-scan/species/feral-pig/logo.svg';
import FoxLogo from '../../assets/images/feral-scan/species/fox/logo.svg';
import MouseLogo from '../../assets/images/feral-scan/species/mouse/logo.svg';
import MynaLogo from '../../assets/images/feral-scan/species/myna/logo.svg';
import NewPestsLogo from '../../assets/images/feral-scan/species/new-pests/logo.svg';
import OtherPestsLogo from '../../assets/images/feral-scan/species/other-pests/logo.svg';
import RabbitLogo from '../../assets/images/feral-scan/species/rabbit/logo.svg';
import StarlingLogo from '../../assets/images/feral-scan/species/starling/logo.svg';
import ToadLogo from '../../assets/images/feral-scan/species/toad/logo.svg';
import WildDogLogo from '../../assets/images/feral-scan/species/wild-dog/logo.svg';

interface INavLogoButtonProps {
    
}

const HeaderLogo = styled(Image)(() => ({
    height: '60px',

    '&:hover': {
        filter: 'brightness(0.7)'
    }
}));

const NavLogoButton: FC<INavLogoButtonProps> = ({
    
}) => {
    const { species: { species } } = useContext(SpeciesContext);

    const logo = useMemo(() => {
        switch (species) {
            case SpeciesTypes.WILDDOG.toSpecies(): return WildDogLogo;
            case SpeciesTypes.DEER.toSpecies(): return DeerLogo;
            case SpeciesTypes.RABBIT.toSpecies(): return RabbitLogo;
            case SpeciesTypes.FERALCAT.toSpecies(): return FeralCatLogo;
            case SpeciesTypes.FOX.toSpecies(): return FoxLogo;
            case SpeciesTypes.FERALPIG.toSpecies(): return FeralPigLogo;
            case SpeciesTypes.MYNA.toSpecies(): return MynaLogo;
            case SpeciesTypes.TOAD.toSpecies(): return ToadLogo;
            case SpeciesTypes.MOUSE.toSpecies(): return MouseLogo;
            case SpeciesTypes.FERALGOAT.toSpecies(): return FeralGoatLogo;
            case SpeciesTypes.FERALFISH.toSpecies(): return FeralFishLogo;
            case SpeciesTypes.STARLING.toSpecies(): return StarlingLogo;
            case SpeciesTypes.OTHERPESTS.toSpecies(): return OtherPestsLogo;
            case SpeciesTypes.NEWPESTS.toSpecies(): return NewPestsLogo;
            default: return FeralScanLogo;
        }
    }, [species]);

    return (
        <Box
            id={'header-logo'}
            sx={{
                alignSelf: 'center',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                lineHeight: 0,
                marginRight: '10px'
            }}
            component={RouteLink}
            to={`/`}
        >
            {
                logo && <HeaderLogo src={logo} />
            }
        </Box>
    );
}

export default NavLogoButton;